import React, { Component } from 'react'
import { Modal, Button, Image, Spin, message } from 'antd'
import { UploadOutlined, CloseCircleTwoTone } from '@ant-design/icons'
import { IMAGE_DOMAIN } from '../../../config'
import TextInputView from '../../../components/textInputView'
import TextTipSwitchView from '../../../components/textTipSwitchView'
import TextSelectView from '../../../components/textSelectView'
import ShiftView from '../../../components/shiftView'
import { round, validateImageFile } from '../../../util/index'
import './employeeModal.css'
import {
  DATA_TYPE,
  basicInfo,
  basicsSalary,
  monthlySalary,
  attendanceShift,
  salaryInfo,
  commoditySales,
  templateSelect,
  authInfo,
  tutorSwitch,
  tutorTypeInfo,
  tutorInfo,
  scoreSwitch,
  scoreInfo,
  operationInfo,
  lookDataInfo,
} from './property'

export default class employeeModal extends Component {
  state = {
    basicInfo: basicInfo(),
    basicsSalary: basicsSalary(),
    monthlySalary: monthlySalary(),
    attendanceShift: attendanceShift(),
    salaryInfo: salaryInfo(),
    commoditySales: commoditySales(),
    templateSelect: templateSelect(),
    authInfo: authInfo(),
    tutorSwitch: tutorSwitch(),
    tutorTypeInfo: tutorTypeInfo(),
    tutorInfo: tutorInfo(),
    scoreSwitch: scoreSwitch(),
    scoreInfo: scoreInfo(),
    operationInfo: operationInfo(),
    lookDataInfo: lookDataInfo(),
    fileList: [], // 图片组 { url, uploaded, file} uploaded: 判断是否已经上传在七牛云上面
    isLoadingDetail: false,
    commissionType:
      this.props.sourceData == null
        ? 1
        : this.props.sourceData.detail.tutor.commissionType,
  }

  componentDidMount() {
    this.refreshSelects()
  }

  // 更新选择类型的界面
  refreshSelects = () => {
    const { shiftList, templateList, chargeList, salaryList } = this.props
    const {
      basicsSalary,
      attendanceShift,
      templateSelect,
      tutorTypeInfo,
      tutorInfo,
    } = this.state
    const bs = basicsSalary.map((item) => {
      item.options = salaryList
      return item
    })
    const as = attendanceShift.map((item) => {
      item.options = shiftList
      return item
    })
    const tl = templateSelect.map((item) => {
      item.options = templateList
      return item
    })
    const cl = tutorTypeInfo.map((item) => {
      item.options = chargeList
      return item
    })
    const ti = tutorInfo.filter((item) => item.dataType != DATA_TYPE.time)
    this.setState(
      {
        basicsSalary: bs,
        attendanceShift: as,
        templateSelect: tl,
        tutorTypeInfo: cl,
        tutorInfo: ti,
      },
      () => {
        const { sourceData } = this.props
        if (sourceData) {
          this.detailSetData(sourceData)
        }
      }
    )
  }

  // 读取员工接口详情更新界面
  detailSetData = (sourceData) => {
    console.log('数据源:', sourceData)
    const { detail, employee, shift, property } = sourceData
    const basicAry = []
    let allData = {}
    for (const key in employee) {
      const value = employee[key]
      if (key == 'avatar') {
        if (value) {
          allData['fileList'] = [{ url: value, uploaded: true, file: null }]
        }
      }
    }
    this.ergodicData(employee, this.state.basicInfo, basicAry)
    allData['basicInfo'] = basicAry // 用户信息

    const shiftAry = []
    this.ergodicData(shift, this.state.attendanceShift, shiftAry)
    allData['attendanceShift'] = shiftAry // 考勤班次

    const sInfoAry = []
    const comAry = []
    const bsAry = []
    const msAry = []
    this.ergodicData(property, this.state.salaryInfo, sInfoAry)
    this.ergodicData(property, this.state.commoditySales, comAry)
    this.ergodicData(property, this.state.basicsSalary, bsAry)
    this.ergodicData(property, this.state.monthlySalary, msAry)
    const nmsAry = msAry.map((item, index) => {
      const bItem = bsAry[index]
      item.title = bItem.value != 2 ? '月薪' : '时薪'
      return item
    })
    allData['salaryInfo'] = sInfoAry // 假期和奖励
    allData['commoditySales'] = comAry // 商品销售提成
    allData['basicsSalary'] = bsAry // 基础薪酬
    allData['monthlySalary'] = nmsAry // 月薪

    const detailObj = this.templateDetail(detail)
    console.log('赋值详情:', detailObj)
    this.setState((prevState) => ({
      ...prevState,
      ...allData,
      ...detailObj,
    }))
  }

  // 读取模板详情 更新界面
  templateDetail = (detail) => {
    let allData = {}
    const { permissions, scorer, tutor } = detail
    for (const stateKey in this.state) {
      if (
        stateKey == 'authInfo' ||
        stateKey == 'tutorSwitch' ||
        stateKey == 'scoreSwitch' ||
        stateKey == 'operationInfo' ||
        stateKey == 'lookDataInfo'
      ) {
        const propertys = this.state[stateKey]
        let newArray = []
        for (let i = 0; i < propertys.length; i++) {
          const pItem = propertys[i]
          pItem.value = permissions[pItem.key]

          if (stateKey == 'operationInfo' || stateKey == 'lookDataInfo') {
            const firstItem = propertys[0]
            if (i > 0) {
              pItem.disabled = !firstItem.value
              if (!firstItem.value) {
                pItem.value = false
              }
            }
          }
          newArray.push(pItem)
        }
        allData[stateKey] = newArray
      }
    }

    const sSwitch = allData['scoreSwitch'][0].value
    let newArray = []
    const scorerInfos = this.state.scoreInfo
    for (let i = 0; i < scorerInfos.length; i++) {
      const item = scorerInfos[i]
      item.disabled = !permissions.scorer ? true : false
      item.required = false
      if (item.dataType == DATA_TYPE.amount) {
        item.value = !sSwitch ? '' : round(scorer[item.key] / 100, 2)
      } else {
        item.value = !sSwitch ? '' : scorer[item.key] / 3600
      }
      newArray.push(item)
    }
    allData['scoreInfo'] = newArray

    let chargeAry = []
    const chargeInfos = this.state.tutorTypeInfo
    for (let i = 0; i < chargeInfos.length; i++) {
      const item = chargeInfos[i]
      item.value = tutor[item.key]
      item.disabled = !permissions.tutor ? true : false
      item.required = permissions.tutor
      chargeAry.push(item)
    }
    allData['tutorTypeInfo'] = chargeAry

    const tSwitch = allData['tutorSwitch'][0].value
    const tutorType = chargeAry[0].value
    let newAry = tutorInfo()
    if (tutorType < 2) {
      newAry = tutorInfo().filter((item) => item.dataType != DATA_TYPE.time)
    }
    let teachAry = []
    const teachInfos = newAry
    for (let i = 0; i < teachInfos.length; i++) {
      const item = teachInfos[i]
      item.disabled = !permissions.tutor ? true : false
      item.required =
        permissions.tutor && item.key === 'duration' ? true : false
      if (
        tutorType < 2 &&
        (item.key !== 'duration' || item.key !== 'timeout')
      ) {
        // 小时收费
        if (item.dataType == DATA_TYPE.amount) {
          item.value = !tSwitch ? '' : round(tutor[item.key] / 100, 2)
        } else {
          item.value = !tSwitch || tutorType == 0 ? '' : tutor[item.key] / 3600
        }
        item.suffix = item.dataType == DATA_TYPE.amount ? '元/小时' : '小时'
        if (item.key == 'commission') {
          item.suffix = ''
        }
        teachAry.push(item)
      } else if (tutorType == 2) {
        if (item.key === 'minCharge') {
          const value = tutor[item.key]
          const duration = tutor['duration']
          item.suffix = '课程'
          item.value = !tSwitch
            ? ''
            : value && duration > 0
            ? value / duration
            : 0
        } else {
          if (item.dataType == DATA_TYPE.amount) {
            item.suffix = '元/课程'
          }
          item.value = !tSwitch
            ? ''
            : round(
                tutor[item.key] /
                  (item.dataType == DATA_TYPE.amount ? 100 : 60),
                2
              )
        }
        teachAry.push(item)
      }
    }
    allData['tutorInfo'] = teachAry
    return allData
  }

  ergodicData = (targetObj, array, newArray) => {
    for (let i = 0; i < array.length; i++) {
      const item = array[i]
      for (const key in targetObj) {
        if (item.key == key) {
          if (item.dataType == DATA_TYPE.amount) {
            item.value = round(targetObj[key] / 100, 2)
          } else {
            item.value = targetObj[key]
          }
        }
      }
      newArray.push(item)
    }
  }

  // 检查未填写项
  checkValues = () => {
    let allAry = []
    for (const key in this.state) {
      if (key !== 'fileList' && key !== 'isLoadingDetail') {
        const ary = this.state[key]
        // allAry.push(...ary)
        allAry = allAry.concat(ary)
      }
    }
    const filterAry = allAry.filter((item) => item.required)
    let flag = true
    for (let i = 0; i < filterAry.length; i++) {
      const item = filterAry[i]
      const value = item.value
      if (!value || value.length == 0) {
        flag = false
        message.error(item.toastTip)
        break
      }
    }
    if (!flag) {
      return flag
    }
    const { tutorTypeInfo, tutorInfo, commissionType, basicInfo } = this.state
    const chargeTypeInfoValue = tutorTypeInfo[0].value
    const durationObj = tutorInfo[0]
    const timeoutObj = tutorInfo[1]
    const amountObj = chargeTypeInfoValue == 2 ? tutorInfo[2] : tutorInfo[0]
    const accountValue = basicInfo[3].value
    const passwordValue = basicInfo[4].value
    if (accountValue && !passwordValue) {
      message.error('请输入收银端密码')
      flag = false
    }
    if (!accountValue && passwordValue) {
      message.error('请输入收银端账号')
      flag = false
    }
    if (this.state.tutorSwitch[0].value) {
      if (chargeTypeInfoValue == 2) {
        const str = /^[1-9]\d*$/
        if (!str.test(tutorInfo[3].value)) {
          message.error('助教最低消费课程为正整数')
          flag = false
        }
        if (+durationObj.value < +timeoutObj.value) {
          flag = false
          message.error(timeoutObj.toastTip)
        }
      }
      if (commissionType == 2 && amountObj.value == 0) {
        message.error('助教服务收费不能为0')
        flag = false
      }
    }
    return flag
  }

  // 保存事件
  confirmHandle = async (saveType) => {
    if (!this.checkValues() || this.state.isLoadingDetail) {
      return
    }
    const { qiniuToken } = this.props
    const { fileList, tutorTypeInfo, tutorSwitch, scoreSwitch } = this.state
    const chargeTypeInfoValue = tutorTypeInfo[0].value
    const tutorFlag = tutorSwitch[0].value
    const scoreFlag = scoreSwitch[0].value

    let avatarUrl = ''
    if (fileList.length > 0 && qiniuToken) {
      for (let i = 0; i < fileList.length; i++) {
        const item = fileList[i]
        if (!item.uploaded) {
          if (!validateImageFile(item.file)) {
            return
          }
          const form = new FormData()
          form.append('token', qiniuToken.token)
          form.append('file', item.file)
          const res = await this.props.postPhotoToQiniu(form)
          if (res && res.url) {
            avatarUrl = IMAGE_DOMAIN + res.url
          }
        } else {
          avatarUrl = item.url
        }
      }
    }
    // 在这里直接构造 接口需要的参数
    const { sourceData } = this.props
    let tutor = {
      amount: 0,
      commission: 0,
      duration: 0,
      id: -1,
      minCharge: 0,
      type: 0,
    }
    let scorer = {
      amount: 0,
      commission: 0,
      duration: 0,
      id: -1,
      minCharge: 0,
      type: 1,
    }
    if (sourceData) {
      tutor = !tutorFlag
        ? tutor
        : {
            ...sourceData.detail.tutor,
          }
      scorer = !scoreFlag
        ? scorer
        : {
            ...sourceData.detail.scorer,
            type: 1,
          }
    }
    let params = {
      detail: {
        permissions: {},
        tutor,
        scorer,
      },
      employee: {
        id: !sourceData ? -1 : sourceData.employee.id,
        avatar: avatarUrl,
      },
      shift: {
        id: -1,
      },
      property: {
        id: !sourceData ? -1 : sourceData.property.id,
      },
      salaries: [],
    }
    for (const key in this.state) {
      for (let i = 0; i < this.state[key].length; i++) {
        const item = this.state[key][i]
        const iKey = item.key
        // 把所有dataType类型是switch值全部放在permissions里面
        // 除了“商品销售提成” 不要放里面
        if (
          item.dataType == DATA_TYPE.switch &&
          iKey != 'isSellingCommissionEnabled'
        ) {
          params.detail.permissions[iKey] = item.value
        } else {
          if (key == 'basicInfo') {
            params.employee[iKey] = item.value
          } else if (key == 'attendanceShift') {
            params.shift['id'] = item.value
          } else if (
            key == 'salaryInfo' ||
            key == 'commoditySales' ||
            key == 'basicsSalary' ||
            key == 'monthlySalary'
          ) {
            if (item.dataType == DATA_TYPE.amount) {
              const aValue = item.value ? parseFloat(item.value) : 0
              params.property[iKey] = round(aValue * 100, 2)
            } else {
              params.property[iKey] = item.value || 0
            }
          } else if (key == 'tutorTypeInfo' || key == 'tutorInfo') {
            if (
              item.dataType == DATA_TYPE.amount ||
              item.dataType == DATA_TYPE.time
            ) {
              const aValue = item.value ? parseFloat(item.value) : 0
              params.detail.tutor[iKey] = round(
                aValue * (item.dataType == DATA_TYPE.amount ? 100 : 60),
                2
              )
            } else if (item.dataType == DATA_TYPE.ext) {
              params.detail.tutor[iKey] =
                chargeTypeInfoValue == 1
                  ? item.value * 3600
                  : item.value * this.state[key][0].value * 60
            } else {
              params.detail.tutor[iKey] = item.value
            }
          } else if (key == 'scoreInfo') {
            const aValue = item.value ? parseFloat(item.value) : 0
            params.detail.scorer[iKey] = round(
              aValue * (item.dataType == DATA_TYPE.amount ? 100 : 3600),
              2
            )
          }
        }
      }
    }
    params.detail.tutor.commissionType = this.state.commissionType
    console.log('构造的上传参数', params)
    this.setState({ isLoadingDetail: true })
    if (saveType == 2) {
      // 保存模板
      params = {
        ...params,
        template: {
          name: params.employee.jobTitle,
        },
      }
      await this.props.saveEmployeeTemplate(params)
      const { templateList } = this.props
      const tl = this.state.templateSelect.map((item) => {
        item.options = templateList
        return item
      })
      this.setState({ isLoadingDetail: false, templateSelect: tl })
      return
    }
    const flag = await this.props.addOrEditEmployee(params)
    this.setState({ isLoadingDetail: false })
    if (flag) {
      this.props.onCloseEvent()
    }
  }

  // 输入组件
  itemInputView = (dataKey, data, index) => {
    return (
      <TextInputView
        item={data}
        inputChange={(e) => this.inputChange(e, dataKey, index)}
        selectValue={
          this.props.sourceData == null
            ? ''
            : this.props.sourceData.detail.tutor.commissionType
        }
        selectChange={(e) => this.selectChange(e)}
        tutorTypeInfo={this.state.tutorTypeInfo}
      ></TextInputView>
    )
  }

  selectChange = (e) => {
    console.log(e)
    this.setState({
      commissionType: e,
    })
  }

  // 输入框回调
  inputChange = (e, dataKey, index) => {
    const { id, value } = e.target
    const val = value.toString().trim()
    const newAry = this.state[dataKey].map((it, idx) => {
      if (idx == index) {
        it.value = val
      }
      return it
    })
    this.setState({
      [dataKey]: newAry,
    })
  }

  // 选择图片组件
  itemUploadView = () => {
    const { fileList } = this.state
    return (
      <div className="text-upload-view">
        <span className="text-tip-class">照片</span>
        <div className="upload-class">
          {fileList &&
            fileList.length > 0 &&
            fileList.map((item, index) => {
              return (
                <div className="upload-image-class-view" key={index}>
                  <div
                    className="upload-close-class"
                    onClick={() => this.deleteFlie(index)}
                  >
                    <CloseCircleTwoTone
                      style={{
                        width: '20px',
                        height: '20px',
                        fontSize: '20px',
                      }}
                      twoToneColor="#ff6e6e"
                    />
                  </div>
                  <Image className="upload-image-view" src={item.url} alt="" />
                </div>
              )
            })}
          {fileList.length < 1 && (
            <Button className="add-photo-class">
              <UploadOutlined />
              <input
                className="file-input-class"
                accept=".jpg,.jpeg,.png"
                type="file"
                onChange={this.onFileUpload}
              />
            </Button>
          )}
        </div>
      </div>
    )
  }

  // 选择图片
  onFileUpload = (e) => {
    const that = this
    const file = e.target.files[0]
    if (!validateImageFile(file)) {
      e.target.value = ''
      return
    }
    let fd = this.state.fileList
    const reader = new FileReader()
    reader.onload = (res) => {
      const basedata = res.target.result
      if (basedata) {
        fd.push({ url: basedata, uploaded: false, file: file })
        that.setState({
          fileList: fd,
        })
      }
    }
    reader.readAsDataURL(file)
  }

  // 删除图片
  deleteFlie = (index) => {
    let fl = this.state.fileList
    fl.splice(index, 1)
    this.setState({
      fileList: fl,
    })
  }

  // 下拉选择组件
  itemSelectView = (dataKey, data, index) => {
    return (
      <div key={index}>
        <TextSelectView
          item={data}
          onSelectChange={(value, option) => {
            this.onSelectChangeEvent(value, option, dataKey, index)
          }}
        ></TextSelectView>
      </div>
    )
  }

  // 选择事件
  onSelectChangeEvent = async (value, option, dataKey, index) => {
    if (dataKey == 'templateSelect') {
      // 如果选择了模板 请求模板数据 套进界面上
      this.setState({ isLoadingDetail: true })
      const data = await this.props.obtainTemplateDetail(value)
      this.setState({ isLoadingDetail: false })
      if (data) {
        const newData = this.state[dataKey].map((item, idx) => {
          if (idx == index) {
            item.value = value
          }
          return item
        })
        this.setState({
          [dataKey]: newData,
        })
      }
      const detailObj = this.templateDetail(data.detail)
      this.setState((prevState) => ({
        ...prevState,
        ...detailObj,
      }))
    } else {
      const newData = this.state[dataKey].map((item, idx) => {
        if (idx == index) {
          item.value = value
        }
        return item
      })
      if (dataKey == 'basicsSalary') {
        const item = this.state.monthlySalary[0]
        item.title = value != 2 ? '月薪' : '时薪'
        this.setState({
          monthlySalary: [item],
        })
      }
      this.checkSelectChange(value, dataKey, index)
      this.setState({
        [dataKey]: newData,
      })
    }
  }

  checkSelectChange = (value, dataKey, index) => {
    if (dataKey === 'tutorTypeInfo') {
      const newInfo = tutorInfo()
      let newAry = []
      if (value == 1) {
        newAry = newInfo.filter((item) => {
          if (item.dataType == DATA_TYPE.amount) {
            item.suffix = '元/小时'
          } else if (item.dataType == DATA_TYPE.ext) {
            item.suffix = '小时'
          }
          if (item.key === 'duration') {
            item.required = true
          } else {
            item.required = false
          }
          item.disabled = false
          return item.dataType != DATA_TYPE.time
        })
      } else {
        newAry = newInfo.map((item) => {
          if (item.dataType == DATA_TYPE.amount) {
            item.suffix = '元/课程'
          } else if (item.dataType == DATA_TYPE.ext) {
            item.suffix = '课程'
          }
          if (item.key === 'duration') {
            item.required = true
          } else {
            item.required = false
          }
          item.disabled = false
          return item
        })
      }
      this.setState({
        tutorInfo: newAry,
      })
    }
  }

  // 开关组件
  itemSwitchView = (dataKey, data, index) => {
    return (
      <div key={index}>
        <TextTipSwitchView
          item={data}
          onSwitchChange={(checked) => {
            this.switchChangeEvent(checked, dataKey, index)
          }}
        ></TextTipSwitchView>
      </div>
    )
  }

  // 开关切换
  switchChangeEvent = (checked, dataKey, index) => {
    const newData = this.state[dataKey].map((item, idx) => {
      if (idx == index) {
        item.value = checked
      }
      return item
    })
    const sItem = this.state[dataKey][index]
    this.checkSwitchChange(dataKey, checked, sItem.key)
    this.setState({
      [dataKey]: newData,
    })
  }

  // 检查主项是否开与关 控制子项是否有操作权限
  checkSwitchChange = (dataKey, checked, targetItemKey) => {
    // 如果是助教服务开关 同时控制下面（收费标准，价格，助教提成）是否可编辑
    if (dataKey == 'tutorSwitch') {
      const ctInfo = this.state.tutorTypeInfo.map((item) => {
        item.required = checked
        item.disabled = !checked
        item.value = 0
        return item
      })
      const ti = tutorInfo().filter((item) => {
        if (checked) {
          if (item.key === 'duration') {
            item.required = true
          }
        } else {
          item.required = false
        }
        item.disabled = !checked
        item.value = !checked ? '' : item.value
        return item.dataType != DATA_TYPE.time
      })
      this.setState({
        tutorTypeInfo: ctInfo,
        tutorInfo: ti,
      })
    }
    // 如果是记分服务开关 控制下面（价格记分提成）是否可编程
    if (dataKey == 'scoreSwitch') {
      const smInfo = this.state.scoreInfo.map((item) => {
        item.required = false
        item.disabled = !checked
        item.value = !checked ? '' : item.value
        return item
      })
      this.setState({
        scoreInfo: smInfo,
      })
    }
    // 如果是运营设置开关 控制下面是否可开关
    if (dataKey == 'operationInfo' && targetItemKey == 'runSettings') {
      const oInfo = this.state.operationInfo.map((item) => {
        if (item.key != 'runSettings') {
          item.disabled = !checked
          item.value = !checked ? false : checked
        }
        return item
      })
      this.setState({
        operationInfo: oInfo,
      })
    }
    // 如果是数据查看开关 控制下面是否可开关
    if (dataKey == 'lookDataInfo' && targetItemKey == 'datasView') {
      const ldInfo = this.state.lookDataInfo.map((item) => {
        if (item.key != 'datasView') {
          item.disabled = !checked
          item.value = !checked ? false : checked
        }
        return item
      })
      this.setState({
        lookDataInfo: ldInfo,
      })
    }
  }

  /*
  显示添加界面
   */
  onShowHandle = () => {
    this.setState({
      visible: true,
    })
  }

  /*
  关闭界面
   */
  onCloseHandle = () => {
    this.setState({
      visible: false,
    })
  }

  /*
  刷新页面
   */
  shiftRefreshView = async () => {
    await this.props.getShiftList()
    this.refreshSelects()
  }

  render() {
    const {
      basicInfo,
      basicsSalary,
      monthlySalary,
      attendanceShift,
      salaryInfo,
      commoditySales,
      templateSelect,
      authInfo,
      tutorTypeInfo,
      tutorSwitch,
      tutorInfo,
      scoreSwitch,
      scoreInfo,
      operationInfo,
      lookDataInfo,
      isLoadingDetail,
    } = this.state
    return (
      <Modal
        visible
        destroyOnClose
        width="1400px"
        onCancel={this.props.onCloseEvent}
        style={{ top: '2%' }}
        footer={[
          <Button
            key={1}
            className="text-cancel-button"
            type="text"
            size="large"
            onClick={this.props.onCloseEvent}
          >
            取消
          </Button>,
          <Button
            key={2}
            className="text-success-button"
            size="large"
            loading={isLoadingDetail}
            onClick={() => {
              this.confirmHandle(2)
            }}
          >
            保存模板
          </Button>,
          <Button
            key={3}
            type="primary"
            size="large"
            loading={isLoadingDetail}
            onClick={() => {
              this.confirmHandle(3)
            }}
          >
            保存设置
          </Button>,
        ]}
      >
        <div className="modal-content-view">
          <div className="left-content">
            {/* 基本信息块 */}
            <div className="tip-class">基本信息：</div>
            {basicInfo.map((data, idx) => {
              return (
                <div className="mr-top-class" key={idx}>
                  {this.itemInputView('basicInfo', data, idx)}
                </div>
              )
            })}
            {this.itemUploadView()}
            {/* 薪酬待遇块 */}
            <div className="tip-class">薪酬待遇：</div>
            {/* 基础薪酬 */}
            {basicsSalary.map((data, idx) => {
              return this.itemSelectView('basicsSalary', data, idx)
            })}
            {/* 月薪 */}
            {monthlySalary.map((data, idx) => {
              return (
                <div className="mr-top-class" key={idx}>
                  {this.itemInputView('monthlySalary', data, idx)}
                </div>
              )
            })}
            {/* 考勤班次 */}
            <div className="mr-top-class">
              {attendanceShift.map((data, idx) => {
                if (data.options.length > 0) {
                  return this.itemSelectView('attendanceShift', data, idx)
                }
                return (
                  <div className="text-select-view" key={idx}>
                    <span className="title-select-class">考勤班次</span>
                    <div className="shift-button-view">
                      <Button
                        type="primary"
                        size="large"
                        onClick={() => this.onShowHandle()}
                      >
                        新增班次
                      </Button>
                    </div>
                  </div>
                )
              })}
            </div>
            {/* 每月假期和全勤奖励 */}
            {salaryInfo.map((data, idx) => {
              return (
                <div className="mr-top-class" key={idx}>
                  {this.itemInputView('salaryInfo', data, idx)}
                </div>
              )
            })}
            {/* 商品销售提成 */}
            {commoditySales.map((item, idx) => {
              return (
                <div className="mr-top-class" key={idx}>
                  {this.itemSwitchView('commoditySales', item, idx)}
                </div>
              )
            })}
            <div className="mr-top-class"></div>
            <div className="tip-class">快速权限模板：</div>
            {templateSelect.map((data, idx) => {
              return this.itemSelectView('templateSelect', data, idx)
            })}
          </div>
          <div className="right-content">
            <div className="right-content-left-view">
              {/* 权限设置块 */}
              <div className="tip-class">权限设置:</div>
              {authInfo.map((item, idx) => {
                if (item.key === 'editMemberManage') {
                  const isShow = authInfo.find(item => item.key === 'checkMemberManage').value
                  if (isShow) {
                    return this.itemSwitchView('authInfo', item, idx)
                  } else {
                    return null
                  }
                }
                return this.itemSwitchView('authInfo', item, idx)
              })}
              {/* 助教服务块 */}
              <div className="service-block-view">
                {tutorSwitch.map((item, idx) => {
                  return this.itemSwitchView('tutorSwitch', item, idx)
                })}
                <div className="mr-top-class">
                  {/* 收费标准 */}
                  {tutorTypeInfo.map((data, idx) => {
                    return this.itemSelectView('tutorTypeInfo', data, idx)
                  })}
                  {tutorInfo.map((data, idx) => {
                    return (
                      <div className="mr-top-class" key={idx}>
                        {this.itemInputView('tutorInfo', data, idx)}
                      </div>
                    )
                  })}
                </div>
              </div>
              {/* 记分服务 */}
              <div className="service-block-view">
                {scoreSwitch.map((item, idx) => {
                  return this.itemSwitchView('scoreSwitch', item, idx)
                })}
                <div className="mr-top-class">
                  {scoreInfo.map((data, idx) => {
                    return (
                      <div className="mr-top-class" key={idx}>
                        {this.itemInputView('scoreInfo', data, idx)}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className="right-content-right-view">
              <div className="tip-class"></div>
              {/* 运营设置 */}
              {operationInfo.map((item, idx) => {
                return this.itemSwitchView('operationInfo', item, idx)
              })}

              <div className="tip-class"></div>
              {/* 数据查看 */}
              {lookDataInfo.map((item, idx) => {
                return this.itemSwitchView('lookDataInfo', item, idx)
              })}
            </div>
          </div>
          {isLoadingDetail && (
            <div className="loading-ant-spin-view">
              <Spin size="large" />
            </div>
          )}
        </div>
        <ShiftView
          onRefreshView={this.shiftRefreshView}
          visible={this.state.visible}
          onCloseEvent={this.onCloseHandle}
        />
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubEmployeeManager/component/employeeModal.js